import React, { ReactElement, useEffect, useState } from 'react';
import { GoForwardButton } from '../GoForwardButton';
import FunctionaryForm from './functionary/functionaryForm';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useHireBussinessPlanForm } from '../../../contexts/HirePlanBussinessFormProvider';
import {
  useFunctionaryAddDataStore,
  useFunctionaryExcelDataStore,
  useFunctionaryIdStore,
  useFunctionaryOpenFormDataStore,
  useFunctionaryOpenModalDataStore,
} from '../../../stores/useFunctionaryStore';
import { useVidaCountStore } from '../../../stores/useQuantidadeVidas';
import { useRouteLoaderData } from 'react-router-dom';
import { changeGender } from '../../../utils/ChangeArrays';
import { Button } from '../../Button';
import { useCepValidator } from '../../../utils/useCepValidor';

export function FunctionaryRegisterForm(): ReactElement {
  const {
    register,
    handleSubmit,
    goToNextForm,
    errors,
    watch,
    setValue,
    setFuncValue,
  } = useHireBussinessPlanForm();
  const initialPlanData: any = useRouteLoaderData('token-empresa');
  const setFuncId = useFunctionaryIdStore(state => state.setId);
  const FuncId = useFunctionaryIdStore(state => state.id);
  const [funcionarioAdicionado, setfuncionarioAdicionado] = useState(false);
  const funcionarios =
    watch('user.funcionarios') != undefined ? watch('user.funcionarios') : [];
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const toggleExpandRow = (index: number) => {
    setExpandedRow(prevIndex => (prevIndex === index ? null : index));
  };
  const setCountVidas = useVidaCountStore(x => x.setVidaCount);
  const Vidas = useVidaCountStore(x => x.count);

  const setFuncionaryOpenModal = useFunctionaryOpenModalDataStore(
    x => x.setfunctionaryOpenModalData,
  );
  const setOpenForm = useFunctionaryOpenFormDataStore(
    x => x.setfunctionaryOpenFormData,
  );
  const setAddFuncionary = useFunctionaryAddDataStore(
    x => x.setfunctionaryAddData,
  );
  const setAddExcel = useFunctionaryExcelDataStore(
    x => x.setfunctionaryExcelData,
  );
  const { validarCep } = useCepValidator();

  useEffect(() => {
    const currentFuncionarios = watch('user.funcionarios') || [];
    let countFunc = 0;
    if (currentFuncionarios) {
      currentFuncionarios.forEach((funcionario, index) => {
        if (funcionario.cpf == undefined || funcionario.cpf == '') {
          removeClick(index);
        } else {
          countFunc = countFunc + 1;
        }
      });
    }
    const countdependentes = currentFuncionarios.reduce(
      (count, funcionario) => {
        return (
          count + (funcionario.dependentes ? funcionario.dependentes.length : 0)
        );
      },
      0,
    );
    const count = countFunc + countdependentes;
    setCountVidas(count);
  }, [funcionarios]);

  const editClick = (index: number) => {
    setFuncId(index);
    setFuncionaryOpenModal(true);
    setOpenForm(true);
    setAddFuncionary(false);
    setAddExcel(false);
  };
  const [error, setError] = useState<string | null>(null);
  const removeClick = (ind: number) => {
    const currentFuncionarios = watch('user.funcionarios') || [];
    const updatedFuncionarios = currentFuncionarios.filter(
      (_, index) => index !== ind,
    );
    setValue('user.funcionarios', updatedFuncionarios);
  };
  changeGender(initialPlanData.listaSexos);

  useEffect(() => {
    if (
      (funcionarios &&
        funcionarios[0] &&
        funcionarios[0].nome != undefined &&
        funcionarios[0].nome != '') ||
      Vidas > 0
    ) {
      setfuncionarioAdicionado(true);
    } else {
      removeClick(0);
      setfuncionarioAdicionado(false);
    }
  }, [Vidas]);
  const validaQTD = async () => {
    if (
      Vidas >= initialPlanData.categoria.nu_vidas_min &&
      Vidas < initialPlanData.categoria.nu_vidas_max
    ) {
      const funcionarios = watch('user.funcionarios');
      const functionaryQuantity = watch('user.functionaryQuantity');
      if (funcionarios.length > parseFloat(functionaryQuantity)) {
        setError(
          'Quantidade de funcionários deve ser menor ou igual a quantidade informada',
        );
        return false;
      } else {
        setError(null);
        const NewError = [];
        for (const funcionario of funcionarios) {
          const cep = watch('user.address.cep');
          const validateCep = await validarCep(cep);
          if (!cep || !validateCep) {
            NewError.push(
              'CEP do funcionário ' + funcionario.nome + ' é inválido.',
            );
            return;
          }
        }
        if (NewError.length > 0) {
          alert(NewError.join('/n'));
          setError(NewError.join(' '));
          return false;
        }
        handleSubmit(goToNextForm)();
        return true;
      }
    } else {
      setError(
        'Quantidade de vidas deve estar obrigatóriamente entre (' +
          initialPlanData.categoria.nu_vidas_min +
          ' e ' +
          initialPlanData.categoria.nu_vidas_max +
          ')',
      );
      return false;
    }
  };
  return (
    <form action="" className="w-full" onSubmit={handleSubmit(goToNextForm)}>
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
        Funcionários
      </h2>
      {funcionarioAdicionado && (
        <table width="100%">
          <thead
            style={{
              background: '#272D65',
              color: '#FFFFFF',
            }}
          >
            <tr className="mb-4">
              <th></th>
              <th style={{ textAlign: 'center' }}>Nome</th>
              <th style={{ textAlign: 'center' }}>CPF</th>
              <th style={{ textAlign: 'center' }}>Data de Nascimento</th>
              <th style={{ textAlign: 'center' }}>Sexo</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {funcionarios.map((funcionario, index) => (
              <React.Fragment key={index}>
                <tr
                  onClick={() => toggleExpandRow(index)}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <td style={{ paddingTop: '15px' }}>
                    {expandedRow === index ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <ArrowForwardIosIcon />
                    )}
                  </td>
                  <td style={{ textAlign: 'center', paddingTop: '15px' }}>
                    {funcionario.nome}
                  </td>
                  <td style={{ textAlign: 'center', paddingTop: '15px' }}>
                    {funcionario.cpf}
                  </td>
                  <td style={{ textAlign: 'center', paddingTop: '15px' }}>
                    {funcionario.dtNascimento}
                  </td>
                  <td style={{ textAlign: 'center', paddingTop: '15px' }}>
                    {funcionario.sexo != '' && funcionario.sexo != undefined
                      ? initialPlanData.listaSexos.find(
                          x => x.Id == funcionario.sexo,
                        ).Nome
                      : ''}
                  </td>
                  <td
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      marginTop: '15px',
                    }}
                  >
                    <Button
                      type="button"
                      text="Editar"
                      onClick={() => editClick(index)}
                      style={{ padding: '15px', height: '2.2rem' }}
                    />
                    <Button
                      type="button"
                      onClick={() => removeClick(index)}
                      text="Remover"
                      style={{
                        background: '#CC0505',
                        padding: '15px',
                        height: '2.2rem',
                      }}
                    />
                  </td>
                </tr>
                {expandedRow === index && funcionario.dependentes && (
                  <tr>
                    <td colSpan={6}>
                      <strong style={{ margin: '2%' }}>Dependentes:</strong>
                      <table width="96%" style={{ margin: '2%' }}>
                        <thead
                          style={{ background: '#DDE1FF', color: '#272D65' }}
                        >
                          <tr>
                            <th style={{ textAlign: 'center' }}>Nome</th>
                            <th style={{ textAlign: 'center' }}>CPF</th>
                            <th style={{ textAlign: 'center' }}>
                              Data de Nascimento
                            </th>
                            <th style={{ textAlign: 'center' }}>Parentesco</th>
                          </tr>
                        </thead>
                        <tbody>
                          {funcionario.dependentes.map(
                            (dependente, depIndex) => (
                              <React.Fragment key={depIndex}>
                                <tr>
                                  <td style={{ textAlign: 'center' }}>
                                    {dependente.nome}
                                  </td>
                                  <td style={{ textAlign: 'center' }}>
                                    {dependente.cpf}
                                  </td>
                                  <td style={{ textAlign: 'center' }}>
                                    {dependente.dtNascimento}
                                  </td>
                                  <td style={{ textAlign: 'center' }}>
                                    {dependente.parentesco
                                      ? initialPlanData.listaParentescos.find(
                                          x => x.Id == dependente.parentesco,
                                        )?.Sigla
                                      : ''}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ),
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
      <div style={{ marginBottom: '20px' }}>
        <FunctionaryForm />
      </div>
      <GoForwardButton addBackButton onForwardClick={validaQTD} tipo="button" />
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
}

export default FunctionaryRegisterForm;
